import {createContext} from 'react';

import {MacroFlowBuilderNodeData} from '../../../../libs/shared/core/src/helpers/types/macroFlowBuilderTypes';
import {FlowBuilderContextType} from '../../../../libs/shared/ui/src/components/decisionTrees/flowBuilder/flowBuilderContext';
import {MacrosAccessPolicyModel} from '../../../models/api/macroModel';
import {MacroFlowBuilderState} from './types';

/*
 * Types.
 */

export interface MacroFlowBuilderContextType
  extends FlowBuilderContextType<MacroFlowBuilderNodeData, MacroFlowBuilderState> {
  macroName: string;
  isTemplateCreation: boolean;
  accessControlState: MacrosAccessPolicyModel;
}

/*
 * Context.
 */

export const MacroFlowBuilderContext = createContext<MacroFlowBuilderContextType | undefined>(undefined);
